import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/fonts/RobotoMono.css'
import './styles/fonts/HeptaSlab.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/index.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

// reportWebVitals(console.log);
